import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Spinner } from "react-bootstrap";
import CategoryCard from "./CategoryCard";
import LoadingSpinner from "../Utilities/LoadingSpinner";
const CategoryContainer = ({ category, loading }) => {
  const { t } = useTranslation()
  const colors = [
    "var(--secondary-color)",
    "#F4DBA5",
    "#55CFDF",
    "#FF6262",
    "#0034FF",
    "var(--secondary-color)",
  ];
  return (
    <Container className="py-5">
      <div className="section-title-modern text-center mb-5">
        <h2 style={{ fontWeight: 800, color: 'var(--primary-color)' }}>{t("All Categories")}</h2>
        <div className="title-underline"></div>
      </div>
      <div className="d-flex flex-wrap justify-content-center" style={{ gap: '20px' }}>
        {loading === false ? (
          category ? (
            category.map((el, index) => {
              return (
                <CategoryCard
                  key={el._id}
                  title={Cookies.get("i18next") === 'ar' ? el.nameAr : el.nameEn}
                  img={el.image}
                  id={el._id}
                  background={colors[Math.floor(Math.random() * 5) + 1]}
                />
              );
            })
          ) : (
            <h3 className="text-center">{t("no categories")}</h3>
          )
        ) : (
          <LoadingSpinner />
        )}
      </div>
    </Container>
  );
};

export default CategoryContainer;
